module.exports = __webpack_public_path__ + "static/media/Week 1 Monday.52bf0748.png";